import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ClindamycinUpsell, LetTheDoctorDecideUti, MetronidazoleUpsell } from '@data/tests';
import { ConsultationStorageService } from '@services/consultation-storage.service';
import { NavigationService } from '@services/navigation.service';

@Injectable({
  providedIn: 'root',
})
export class VaginalCreamAllowedGuard implements CanActivate {
  private navigationService = inject(NavigationService);
  private router = inject(Router);
  private consultationStorageService = inject(ConsultationStorageService);

  private bvPillTestIds: number[] = [MetronidazoleUpsell.id, ClindamycinUpsell.id, LetTheDoctorDecideUti.id];

  /**
   * Determines whether the current route can be activated.
   *
   * @param {ActivatedRouteSnapshot} route the route to be activated
   * @param {RouterStateSnapshot} state the current router state
   *
   * @returns {Promise<boolean | UrlTree>} a promise that resolves to true if the route can be activated, or a UrlTree
   * to redirect otherwise
   */
  public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const nextPageUrl = await this.navigationService.getConsultationRequestNextPageUrl(
      this.consultationStorageService.treatmentType,
      state.url,
    );

    return this.bvPillOrdered() ? true : this.router.createUrlTree([nextPageUrl]);
  }

  /**
   * Checks if the patient has ordered the BV pill.
   *
   * @returns {boolean} true if the user has ordered the BV pill, false otherwise
   */
  private bvPillOrdered(): boolean {
    return this.consultationStorageService.orderedTests.some((test) => this.bvPillTestIds.includes(test.test_id));
  }
}
